import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getExternalManagePaidUsersUrl } from '../../../urls/getExternalManagePaidUsersUrl';
import { getUsersSeatsUrl } from '../../../urls/getUsersSeatsUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const FreeUserDowngradedTooltip = ({
  children,
  isNewSeatingModel
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link
    },
    message: isNewSeatingModel ? 'routing-ui.routingRules.users.needsSeat_jsx' : 'routing-ui.routingRules.users.freeAssignment_jsx',
    options: {
      external: true,
      href: isNewSeatingModel ? getUsersSeatsUrl() : getExternalManagePaidUsersUrl()
    }
  }),
  children: children
});
FreeUserDowngradedTooltip.displayName = 'FreeUserDowngradedTooltip';
export default FreeUserDowngradedTooltip;